const services = [
  {
    id: 'organic',
    title: '100% Organic',
    icon: 'eco',
    description: "Pure, pesticide-free blooms directly from nature's lap.",
  },
  {
    id: 'fast',
    title: '2-Hour Delivery',
    icon: 'electric_bolt',
    description: 'Swift hyperlocal delivery within your neighborhood.',
  },
  {
    id: 'direct',
    title: 'Direct from Seller',
    icon: 'person_pin_circle',
    description: 'No middlemen. Straight from the local flower artisan.',
  },
  {
    id: 'bulk',
    title: 'Bulk Orders',
    icon: 'inventory_2',
    description: 'Exclusive wholesale pricing for events and businesses.',
  },
];

export default services;
